import React, { useState } from 'react'
import { ROOT_VIEW, REFERENTIAL_VIEW } from './constants'
import Referential from './Referential'
import Root from './Root'

const ModalWidget = ({ card }) => {
  const [view, setView] = useState(ROOT_VIEW)

  switch (view) {
    case ROOT_VIEW:
      return <Root setView={setView} card={card} />
    case REFERENTIAL_VIEW:
      return <Referential setView={setView} card={card} />
    default:
      return null
  }
}

export default ModalWidget
